import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { PxdColumns } from '@app/shared/kendoui/grid/interfaces/pxd-columns';
import { DynamicGridDirective } from '../../directives/dynamic-grid.directive';

@Component({
  selector: 'pxd-grid',
  templateUrl: './pxd-grid.component.html',
  styleUrls: ['./pxd-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    DynamicGridDirective,
  ],
})
export class PxdGridComponent {
  readonly data = input<any[]>(undefined);
  readonly columns = input<PxdColumns[]>(undefined);
  readonly grid = input<string>('default');
  readonly columnSettingsKey = input<string>(undefined);
  readonly gridConfig = input<any>(undefined);
  readonly lockSelectionCheckbox = input<boolean>(true);
}